// extracted by mini-css-extract-plugin
export default {"team-fields":"styles_team-fields__gVUwg","team-fields-wrap":"styles_team-fields-wrap__MVzFH"};